// @flow weak

import {GET, POST, PUT} from '../helpers/request';
import {ADD as NOTIFICATION} from './notification';

export const GET_REQUEST = '@workerTypeView/GET_REQUEST';
export const GET_SUCCESS = '@workerTypeView/GET_SUCCESS';
export const GET_FAILURE = '@workerTypeView/GET_FAILURE';

export const UPDATE_REQUEST = '@workerTypeView/UPDATE_REQUEST';
export const UPDATE_SUCCESS = '@workerTypeView/UPDATE_SUCCESS';
export const UPDATE_FAILURE = '@workerTypeView/UPDATE_FAILURE';

export const CREATE_REQUEST = '@workerTypeView/CREATE_REQUEST';
export const CREATE_SUCCESS = '@workerTypeView/CREATE_SUCCESS';
export const CREATE_FAILURE = '@workerTypeView/CREATE_FAILURE';

export const RESET = '@workerTypeView/RESET';
export const CLEAR = '@workerTypeView/CLEAR';

const workerTypeRequest = () => ({
  type: GET_REQUEST,
});

const workerTypeSuccess = workerType => ({
  type: GET_SUCCESS,
  workerType,
});

const workerTypeFailure = error => ({
  type: GET_FAILURE,
  error,
});

const workerTypeUpdateRequest = () => ({
  type: UPDATE_REQUEST,
});

const workerTypeUpdateSuccess = workerType => ({
  type: UPDATE_SUCCESS,
  workerType,
  [NOTIFICATION]: {
    message: 'Yrkeskategori uppdaterad',
  },
});

const workerTypeUpdateFailure = error => ({
  type: UPDATE_FAILURE,
  error,
});

const workerTypeCreateRequest = () => ({
  type: CREATE_REQUEST,
});

const workerTypeCreateSuccess = workerType => ({
  type: CREATE_SUCCESS,
  workerType,
  [NOTIFICATION]: {
    message: `Yrkeskategori ${workerType.name} skapad`,
  },
});

const workerTypeCreateFailure = error => ({
  type: CREATE_FAILURE,
  error,
});

export const fetchWorkerType = id => async dispatch => {
  dispatch(workerTypeRequest());
  try {
    const workerType = await GET({endpoint: `/workertypes/${id}`}, dispatch);
    dispatch(workerTypeSuccess(workerType));
  } catch (err) {
    dispatch(workerTypeFailure(err));
  }
};

export const updateWorkerType = (id, body) => async dispatch => {
  dispatch(workerTypeUpdateRequest());
  try {
    const workerType = await PUT({
      endpoint: `/workertypes/${id}`,
      body,
    }, dispatch);
    dispatch(workerTypeUpdateSuccess(workerType));
  } catch (err) {
    dispatch(workerTypeUpdateFailure(err));
  }
};

export const createWorkerType = body => async dispatch => {
  dispatch(workerTypeCreateRequest());
  try {
    const workerType = await POST({
      endpoint: '/workertypes',
      body,
    }, dispatch);
    dispatch(workerTypeCreateSuccess(workerType));
  } catch (err) {
    dispatch(workerTypeCreateFailure(err));
  }
};

export const clearWorkerType = () => ({
  type: CLEAR,
});

export const reset = () => ({
  type: RESET,
});



// WEBPACK FOOTER //
// ./src/actions/workerTypeView.js